<div class="grid-1-auto app-space-right_0_25">
  <h5>{{getGlobal('Task')}} {{data?.vorgNr}}</h5>
  <div>
    <em class="typo-right typo-small">
      {{enumSvc.getEnumerationText(data.vorg_enmName_VorgangTyp,
      data.vorg_enmIdent_VorgangTyp)}}
    </em>
    <em class="typo-right typo-small">
      {{enumSvc.getEnumerationText(data.vorg_enmName_VorgangStatus,
      data.vorg_enmIdent_VorgangStatus)}}
    </em>
  </div>
</div>
<div class="typo-container-s-s-q typo-small">
  <ng-container *ngIf="getOEByID(data.vorg_oid_Bearbeiter) as OE">
    <span class="typo-small">Bearbeiter: </span>
    <span>
      <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
    </span>
    <q></q>
  </ng-container>
  <span class="typo-small">Beschreibung: </span>
  <span style="white-space: pre-wrap">{{data.vorgBeschreibung}}</span>
  <q></q>
  <!-- Schadenort -->
  <ng-container *ngIf="Schadenort">
  <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}</span>
  <span>
    <ng-container *ngIf="Schadenort as address">
      <em>{{address.adrStr}} {{address.adrHNum}} </em>
      <em>{{address.adrPlz}} {{address.adrOrt}}</em>
    </ng-container>
    <br/>
  </span>
  <q></q>
  </ng-container>
</div>
